var ClientAuthMethod;

(function (ClientAuthMethod) {
  ClientAuthMethod["Cookies"] = "cookies";
})(ClientAuthMethod || (ClientAuthMethod = {}));

export default ClientAuthMethod;